import { render } from "./SubmissionDetailView.vue?vue&type=template&id=947582e2&scoped=true"
import script from "./SubmissionDetailView.vue?vue&type=script&lang=js"
export * from "./SubmissionDetailView.vue?vue&type=script&lang=js"

import "./SubmissionDetailView.vue?vue&type=style&index=0&id=947582e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947582e2"]])

export default __exports__